export const publicImageUrl = value => value?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${value}` : value;